import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import ui from "./modules/ui";
import remitoTemplates from "./modules/remitoTemplates";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    ui,
    remitoTemplates,
  },
  strict: process.env.NODE_ENV !== "production",
});
